// extracted by mini-css-extract-plugin
export default {"page_title3":"SectionTitle3_page_title3__xg8CE","center":"SectionTitle3_center__ZFP95"};